import { render, staticRenderFns } from "./SelfEdit.vue?vue&type=template&id=6881895f&"
import script from "./SelfEdit.vue?vue&type=script&lang=js&"
export * from "./SelfEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports